<template>
	<div class="share-container">
		<div class="card px-2">
			<div class="card-header mt-2">
				<div class="row">
					<div class="col text-start">
						Share Hourglass Land Mint
					</div>
					<div class="col-auto close" @click="$emit('close')">
						<i class="fa fa-close"></i>
					</div>
				</div>
			</div>
			<div class="card-body text-center">
				<div class="row">
					<div class="col hover-scale">
						<a target="_blank" :href="twitter" class="social-icon">
							<img alt="" src="/img/icons/social/twitter.svg" height="60" class="p-2">
						</a>
						<p class="mb-0 mt-2 small">Twitter</p>
					</div>
					<div class="col hover-scale">
						<a target="_blank" :href="facebook" class="social-icon">
							<img alt="" src="/img/icons/social/Facebook.svg" height="60" class="p-1">
						</a>
						<p class="mb-0 mt-2 small">Facebook</p>
					</div>
					<div class="col hover-scale">
						<a target="_blank" :href="telegram" class="social-icon">
							<img alt="" src="/img/icons/social/telegram.svg" height="60" class="p-1">
						</a>
						<p class="mb-0 mt-2 small">Telegram</p>
					</div>
					<div class="col hover-scale">
						<a @click="toClipboard" class="social-img">
							<img alt="" src="/img/icons/social/copy.svg" height="60" class="p-2">
						</a>
						<p class="mb-0 mt-2 small">Copy Link</p>
					</div>

					<div class="col-12 mt-4 hover-scale">
						<div class="input-group" @click="toClipboard">
							<input id="share-link" :value="website" class="form-control" type="text">
							<span class="input-group-text" id="basic-addon1"><i class="fa fa-copy"></i></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ShareSite",
	data() {
		return {
			website: "https://example.com",
			message: "",
			social: {
				facebook: "https://twitter.com/hourglass_ab",
				discord: "https://discord.gg/cgKGFQG4jM"
			}
		}
	},
	computed:{
		facebook: function() {
			return `https://www.facebook.com/share.php?u=${this.website}`
		},
		twitter: function() {
			return `https://twitter.com/intent/tweet?text=${this.message}`
		},
		telegram: function() {
			return `https://t.me/share/url?url=${this.website}&text=${this.message}`
		},
	},
	methods: {
		toClipboard: function () {
			// Get the text field
			let copyText = document.getElementById("share-link");

			// Select the text field
			copyText.select();
			copyText.setSelectionRange(0, 99999); // For mobile devices

			// Copy the text inside the text field
			navigator.clipboard.writeText(copyText.value);

			this.$toastr.s("Share link copied to clipboard","Link copied")
		}
	}
}
</script>

<style scoped>
.share-container {
	position: fixed;
	top: 12vh;
	right: 5vh;
	width: 400px;
	animation: fadeIn 0.5s ease-in-out;
}

.input-group-text {
	background: var(--bs-container);
	border: none;
	fill: white;
	color: white;
}

.social-img {
	border-radius: 33px;
}

.social-img img {
	filter: invert();
}

.hover-scale img {
	transition: all 0.3s ease;
	cursor: pointer;
}

.col:hover.hover-scale img {
	transform: scale(1.2);
}

.social-icon img {
	border-radius: 33px;
	filter: unset;
}

.close {
	cursor: pointer;
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>